import { render } from "./TheNoPermission.vue?vue&type=template&id=6e0f437c"
import script from "./TheNoPermission.vue?vue&type=script&lang=js"
export * from "./TheNoPermission.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__